import { Component, Injectable, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, Validators } from '@angular/forms';
import { ICatCompany } from '../management/document/list-documents.component';
import { EventService } from 'src/app/Service/event.service';
import { CompanyService } from 'src/app/Service/company-service.service';
import { EnumUserRol } from 'src/app/models/shared/app-enums';
import { AuthService } from 'src/app/Service/auth.service';
import { NgOption } from '@ng-select/ng-select';
import { SharedConstants } from 'src/app/models';
import { CatStatusGeneric } from 'src/app/models/shared/cat-status-generic';
import { utilsApps } from 'src/app/helpers/utils-app';
import { CatActionType, CatGeneric } from 'src/app/models/shared/cat-generic';
import { HistoryService } from 'src/app/Service/history.service';
import { DateRange, MatDateRangeSelectionStrategy } from '@angular/material/datepicker';
import { DateAdapter } from '@angular/material/core';
import { ErrorCustomService } from 'src/app/Service/error-service.service';
import { TranslateService } from '@ngx-translate/core';
import { PaginationTableService } from '../shared/pagination/pagination-table/pagination-table.service';

@Injectable()
export class DayRangeSelectionStrategy<D> implements MatDateRangeSelectionStrategy<D> {
  constructor(private readonly _dateAdapter: DateAdapter<D>) { }

  selectionFinished(date: D | null): DateRange<D> {
    console.log("selectionFinished", date);
    return this._createFiveDayRange(date);
  }

  createPreview(activeDate: D | null): DateRange<D> {
    console.log("createPreview", activeDate);
    return this._createFiveDayRange(activeDate);
  }

  private _createFiveDayRange(date: D | null): DateRange<D> {
    console.log("_createFiveDayRange", date);
    if (date) {
      const start = this._dateAdapter.addCalendarDays(date, -15);
      const end = this._dateAdapter.addCalendarDays(date, 15);
      return new DateRange<D>(start, end);
    }
    return new DateRange<D>(null, null);
  }

  private _createDayRange(date: D | null): DateRange<D> {
    console.log("_createFiveDayRange", date);

    //let _init =  this.fmFilters.get('txtDateInit').value;

    if (date) {
      const start = date;// this._dateAdapter.addCalendarDays(date, -15);
      // const end = this._dateAdapter.addCalendarDays(date, 30);
      // return new DateRange<D>(start, end);

      //const end = this._dateAdapter.addCalendarDays(date, 30);
      return new DateRange<D>(start, null);
    }

    return new DateRange<D>(null, null);
  }

}

export interface IFilterSearchHistory {
  companyId: string,
  branchId: number,
  userId: string,
  statusId: number,
  clientName: string | null,
  fatherSurname: string | null,
  motherSurname: string | null,
  dateInitFormated: string,
  dateEndFormated: string
}
@Component({
  selector: 'app-lista-expediente',
  templateUrl: './list-history.component.html'
})

export class ListHistoryComponent implements OnInit, OnDestroy {

  protected todayDate: Date = new Date();

  dataResult = <any>[];
  catStatus: CatStatusGeneric[] = [];
  catLogType: CatActionType[] = [];
  catOrigin: CatGeneric[] = [];

  regexPattern: string;
  regexOnlyNumber: string;
  regexCURP: string;

  loadPage: boolean = false;
  _util = new utilsApps();

  dataInformation = <any>[];

  /** Variables of pagination */
  protected totalPages: number = 1;
  protected currentPage: number = 1;

  rotate = true;
  resetTable = false;
  emptyDataList: boolean = true;
  msgDataEmpty: string = 'No encontramos resultados. Ingresa una nueva búsqueda';
  IsPostBack = false;

  currentUser: any;
  catCompany: ICatCompany[] = [];
  catBranches: NgOption[] = [];
  catUsers: NgOption[] = [];
  showDdlCompany: boolean = false;
  currentCompanyId: string;
  currentApiKey: string;
  waitFor = false;
  dataBranch: any;
  branchId: string;
  userId: string;
  companyId: string;
  currentBranchId: string;
  currentFilter: IFilterSearchHistory = {
    companyId: '',
    branchId: 0,
    userId: '',
    clientName: '',
    fatherSurname: '',
    motherSurname: '',
    statusId: 0,
    dateInitFormated: '',
    dateEndFormated: ''
  };

  fmFilters: any;

  catMsg = [
    { keyLg: "common.errorGetCat", textValue: "Ocurrió un error al obtener la información del catálogo." },
    { keyLg: "common.errorGet", textValue: "Ocurrió un error al obtener la información." },
    { keyLg: "binnacle.msgPeriodNotValid", textValue: "Para continuar es necesario seleccionar un periodo válido." },
    { keyLg: "binnacle.msgRecordsNotFound", textValue: "No es posible generar el reporte porque no hay resultado de su búsqueda." },
    { keyLg: "binnacle.msgDate30", textValue: "Para continuar es necesario seleccionar un periodo menor a 30 días." },
    { keyLg: "binnacle.msgDateMax30", textValue: "El rango seleccionado no debe exceder a 30 días." },
    { keyLg: "binnacle.msgDateNotValid", textValue: "La fecha fin no puede ser mayor a la fecha actual." },
    { keyLg: "common.error500_download", textValue: "Ha ocurrido un error al intentar descargar los datos. Por favor consulte a su administrador." },
  ];

  protected isShowMoreFilters: boolean = false;

  constructor(
    private readonly http: HttpClient,
    private readonly _service: CompanyService,
    private readonly _serviceHistory: HistoryService,
    private readonly fb: FormBuilder,
    private readonly _errorS: ErrorCustomService,
    private readonly sharedConstants: SharedConstants,
    private readonly authService: AuthService,
    private readonly translate: TranslateService,
    private readonly paginationTableService: PaginationTableService,
    protected eventService: EventService
  ) {

    this.authService.currentUser.subscribe(resp => {
      if (resp === null || resp.username === undefined)
        this.currentUser = null;
      else
        this.currentUser = resp;
      if (this.currentUser.roles[0].id == EnumUserRol.SUPER_ADMIN) {
        this.showDdlCompany = true;
      }
    });

    this.currentApiKey = this.currentUser.apiKey;
    this.loadPage = false;
    this.regexPattern = this.sharedConstants.regexPattern.alphanumeric;
    this.regexOnlyNumber = this.sharedConstants.regexPattern.numeric;
    this.regexCURP = this.sharedConstants.regexPattern.curp;


    this.fmFilters = this.fb.group({
      ddlCompany: [''],
      ddlBranch: [''],
      ddlUser: [''],
      ddlStatus: [''],
      ddlLogType: [''],
      ddlOrigin: [''],
      txtFullName: ['', [Validators.maxLength(150), Validators.pattern(this.regexPattern)]],
      txtName: ['', [Validators.maxLength(50), Validators.pattern(this.regexPattern)]],
      txtFatherSurname: ['', [Validators.maxLength(50), Validators.pattern(this.regexPattern)]],
      txtMotherSurname: ['', [Validators.maxLength(50), Validators.pattern(this.regexPattern)]],
      txtDateInit: [this._util.fnAddDays(-30), [Validators.required]],
      txtDateEnd: [new Date(), [Validators.required]],
    });

    //Llenar los filtros con valores default
    this.currentFilter.companyId = this.currentUser.branches[0].idCompany;
    this.currentFilter.branchId = this.currentUser.branches[0].id;
    this.currentFilter.userId = this.currentUser.id;
    this.currentFilter.statusId = 1;
    this.onLoadCat();
  }

  onLoadCat() {
    try {
      //Cat estatus del enrolamiento
      this.catStatus = [
        { id: -1, name: "Todos", value: "-1", keyLg: "All" },
        { id: 0, name: "N/A", value: "0", keyLg: "NA" },
        { id: 1, name: "Exitoso", value: "1", keyLg: "Success" },
        { id: 2, name: "En Revisión", value: "2", keyLg: "InReview" },
        { id: 3, name: "Rechazado", value: "3", keyLg: "Reject" },
      ];

      this.catOrigin = [
        { id: 0, name: "Todos", value: "0", keyLg: "All" },
        { id: 1, name: "Android", value: "1" },
        { id: 2, name: "iOS", value: "2" },
        { id: 3, name: "Web", value: "3" },
        { id: 4, name: "Android asistido", value: "4", keyLg: "AndroidAssisted" }
      ];
      this.f['ddlOrigin'].setValue("0");

      //Mandar el id del estatus
      this.f['ddlStatus'].setValue("-1");

      //Cat compañías/sucursales
      this.loadCompanies();

      this.currentCompanyId = this.currentFilter.companyId;
      //Cat tipo de acción 
      this.loadLogType();

      this.getDataLanguage();

    } catch (error) {
      console.log(error);
    }
  }

  getDataLanguage() {
    this.catStatus.forEach(element => {
      this.translate.stream('dashboard.catStatus.' + element.keyLg).subscribe((res: string) => {
        element.name = res;
      });
    });

    this.catOrigin.forEach(element => {
      if (element.keyLg) {
        this.translate.stream('common.catOrigen.' + element.keyLg).subscribe((res: string) => {
          element.name = res;
        });
      }
    });

    console.log(this.catLogType);


    this.catMsg.forEach(element => {
      if (element.keyLg) {
        this.translate.stream(element.keyLg).subscribe((res: string) => {
          element.textValue = res;
        });
      }
    });

    this.translate.stream('common.msgEmptyGrid').subscribe((res: string) => {
      this.msgDataEmpty = res;
    });
  }


  removeFilter() {
    window.location.reload();
  }

  get f() {
    return this.fmFilters.controls;
  }


  loadLogType() {

    let _resultado: CatActionType[] = [];
    _resultado.push({
      id: 0,
      key: '00',
      type: '',
      description: 'Todas'
    });
    this.catLogType = _resultado;

    this.waitFor = true;
    this.eventService.startLoadingData();
    this._serviceHistory.GetLogsTypeList().subscribe({
      next: (response: any) => {
        let _resultadoCat = response.body;
        console.log("GetLogsTypeList=>", _resultadoCat);
        this.f['ddlLogType'].setValue("00");
        this.catLogType = _resultado.concat(_resultadoCat);
        this.eventService.completeLoadingData();
        this.waitFor = false;

        this.catLogType.forEach(element => {
          if (element.key) {
            this.translate.stream('binnacle.catLogType.' + element.key).subscribe((res: string) => {
              element.description = res;
            });
          }
        });

      },
      error: (error: Response) => {
        let _msg = this.catMsg.find(x => x.keyLg == "common.errorGetCat");
        this.eventService.errorMessage(3, _msg.textValue);
        console.log(error);
      }
    });
  }

  loadCompanies() {
    this.waitFor = true;
    this.eventService.startLoadingData();
    this.fmFilters.get('ddlCompany').disable();
    this._service.GetCompaniesList().subscribe({
      next: (response: any) => {
        let _resultado = response.body;
        console.log("Compañías=>", _resultado);
        //Llenar el listado inicial 
        _resultado.forEach(element => {
          let item: ICatCompany = {
            companyId: element.id,
            companyApiKey: element.apiKey,
            description: element.id + ' - ' + element.name
          };
          this.catCompany.push(item);
        });
        //Mandar el id de la compañía 
        this.f['ddlCompany'].setValue(this.currentCompanyId);
        if (this.currentUser.roles[0].id !== EnumUserRol.SUPER_ADMIN) {
          this.fmFilters.get('ddlCompany').disable();
        }
        else {
          this.fmFilters.get('ddlCompany').enable();
        }

        this.eventService.completeLoadingData();
        this.waitFor = false;
        this.loadBranches();
      },
      error: (error: Response) => {
        let _msg = this.catMsg.find(x => x.keyLg == "common.errorGetCat");
        this.eventService.errorMessage(3, _msg.textValue);
        console.log(error);
      }
    });
  }
  onChangeCompany(event: any) {
    //console.log(this.catCompany);
    this.currentCompanyId = event.value;
    let companySelected = this.catCompany.find(x => x.companyId == this.currentCompanyId);
    if (companySelected != undefined) {
      console.log(companySelected);
      console.log("this.currentCompanyId", this.currentCompanyId);
      this.currentApiKey = companySelected.companyApiKey;
      localStorage.setItem('_company', this.currentCompanyId);
      this.loadBranches();
    }
    else {
      let _msg = this.catMsg.find(x => x.keyLg == "common.errorGet");
      this.eventService.warningMessage(_msg.textValue);
    }
  }

  ngOnInit() {
    try {
      console.log("ngOnInit");
      setTimeout(() => {
        this.loadData();
      }, 1500);

    } catch (error) {
      console.log('Error: ' + error);
    }
  }

  /** For when the page is closed */
  public ngOnDestroy(): void {
    localStorage.removeItem('currentPage');
    localStorage.removeItem('searchField');
  }

  onChangeBranch(event: any) {
    this.currentBranchId = event.value;
    this.branchId = event.value;
    localStorage.setItem('_branch', this.branchId);
    this.loadUsersForBranch(event.value);
  }

  loadUsersForBranch(branchId: any) {

    console.log("currentUser=> ", this.currentUser);
    console.log("loadUsersForBranch", branchId);
    this.branchId = branchId;
    this.catUsers = [];
    //Se crea un cat con todos
    this.catUsers.push({
      id: 0,
      username: 'Todos',
      keyLg: "All"
    });
    this.f['ddlUser'].setValue("0");

    this.catUsers.forEach(element => {
      if (element.keyLg) {
        this.translate.stream('common.catUser.' + element.keyLg).subscribe((res: string) => {
          element.username = res;
        });
      }
    });

    this.eventService.startLoadingData();
    this.fmFilters.get('ddlUser').disable();

    if (this.branchId != '0') {
      this.http.get('/auth/users/branch/'
        + this.branchId + '/'
        + this.currentApiKey
      ).subscribe(
        (response: any) => {
          //console.log("BranchId", this.branchId);
          console.log("Usuarios en suc=> ", response);
          response.forEach((element: any) => {
            this.catUsers.push({ id: element.id, username: element.username });
          });
          if (this.currentUser.roles[0].id == EnumUserRol.SUPER_ADMIN || this.currentUser.roles[0].id == EnumUserRol.ADMIN) {
            this.f['ddlUser'].setValue("0");
            this.fmFilters.get('ddlUser').enable();
          }
          else {
            if (this.catUsers.length == 1) {
              this.catUsers.push({
                id: this.currentUser.id,
                username: this.currentUser.username,
              });
            }
            this.f['ddlUser'].setValue(this.currentUser.id.toString());
            this.fmFilters.get('ddlUser').disable();
          }

          console.log(this.catUsers);
          this.eventService.completeLoadingData();
        },
        (error: Response) => {
          console.log(error);
          this.eventService.completeLoadingData();
          this.waitFor = false;
        }
      );
    }
    else {
      this.eventService.completeLoadingData();
    }
  }

  loadBranches() {
    this.eventService.startLoadingData();
    this.fmFilters.get('ddlBranch').enable();
    let _data = [];
    _data.push({
      id: 0,
      name: '0000 - Todas',
      keyLg: "All"
    });

    _data.forEach(element => {
      if (element.keyLg) {
        this.translate.stream('common.catBranches.' + element.keyLg).subscribe((res: string) => {
          element.name = res;
        });
      }
    });

    let url = "";
    if (this.currentUser.roles[0].id !== EnumUserRol.SUPER_ADMIN) {
      url = '/auth/branches?userId=' + this.currentUser.id;
    }
    else {
      url = '/auth/branches/company/' + this.currentApiKey;
    }
    console.log("Sucursales url=>", url);
    this.dataBranch = this.http.get(url).subscribe(
      (response: any) => {
        console.log("Sucursales=>", response);
        response.forEach((element: any) => {
          if (element.name.toLowerCase() == "online") {
            _data.push({
              id: element.id,
              name: element.key + ' - ' + element.name + ' ' + element.alias,
            });
          }
          else {
            _data.push({
              id: element.id,
              name: element.key + ' - ' + element.name,
            });
          }
        });


        this.catBranches = _data;

        if (this.currentUser.roles[0].id == EnumUserRol.SUPER_ADMIN ||
          this.currentUser.roles[0].id == EnumUserRol.ADMIN) {
          this.fmFilters.get('ddlBranch')?.setValue(this.catBranches.find(b => b.id === 0).id.toString());
          this.fmFilters.get('ddlBranch').enable();
        }
        else {
          this.f['ddlBranch'].setValue(this.currentFilter.branchId.toString());
          this.fmFilters.get('ddlBranch').disable();
        }
        this.eventService.completeLoadingData();
        this.loadUsersForBranch(this.currentFilter.branchId.toString());
      },
      (error: Response) => {
        this.eventService.completeLoadingData();
        this.waitFor = false;
      }
    );
  }

  protected searchInfo() {
    this.currentPage = this.paginationTableService.resetPageCurrent();
    let txtDateInit = this.fmFilters.get('txtDateInit').value;
    let txtDateEnd = this.fmFilters.get('txtDateEnd').value;


    if (txtDateInit == null || txtDateEnd == null) {
      let _msg = this.catMsg.find(x => x.keyLg == "binnacle.msgPeriodNotValid");
      this.eventService.warningMessage(_msg.textValue);
      return;
    }
    this.onValidatePeriod();
    this.loadData();
  }

  getParameters(): string {
    let _result = "";
    let companyId = this.currentUser.branches[0].idCompany;

    let _util = new utilsApps();
    let _init = _util.formatDate2(this.fmFilters.get('txtDateInit').value);
    let _end = _util.formatDate2(this.fmFilters.get('txtDateEnd').value);


    if (this.currentUser.roles[0].id == EnumUserRol.SUPER_ADMIN) {
      companyId = this.fmFilters.get('ddlCompany')?.value;
    }
    /*let Name = this.fmFilters.get('txtName')?.value;
    let FatherSurname = this.fmFilters.get('txtFatherSurname')?.value;
    let MotherSurname = this.fmFilters.get('txtMotherSurname')?.value;*/
    let fullName = this.fmFilters.get('txtFullName')?.value;
    let nameParam = /*((Name.toString() != '') ? Name : '') +
      ((FatherSurname.toString() != '') ? ' ' + FatherSurname : '') +
      ((MotherSurname.toString() != '') ? ' ' + MotherSurname : '')*/((fullName.toString() != '') ? fullName : '');

    let branchId = this.fmFilters.get('ddlBranch').value;
    if (branchId == '0') {
      branchId = '';
    }
    let userId = this.fmFilters.get('ddlUser').value;
    if (userId == '0') {
      userId = '';
    }

    let origenId = this.fmFilters.get('ddlOrigin').value;
    if (origenId == '0') {
      origenId = '';
    }

    let key = this.fmFilters.get('ddlLogType').value;
    if (key == '00') {
      key = '';
    }

    let statusEnroll = this.fmFilters.get('ddlStatus').value;
    if (statusEnroll == '-1') {
      statusEnroll = '';
    }

    let successManual = (statusEnroll === -1 || statusEnroll === '') ? '' : (statusEnroll == 1);

    let _parametros = [
      'startDate=' + _init,
      'endDate=' + _end,
      'branchId=' + branchId,
      'userId=' + userId,
      'companyId=' + companyId,
      'origin=' + origenId,
      'key=' + key,
      'status=' + statusEnroll,
      'successManual=' + successManual,
      'name=' + nameParam.trim()
    ].join('&');

    if (statusEnroll === -1 || statusEnroll === '') {
      _parametros = _parametros.replace("&status=", "").replace("&successManual=", "");
    }

    console.log("_parametros=>", _parametros);
    _result = _parametros;

    return _result;
  }

  onExportPDF(): any {

    if (this.emptyDataList) {
      let _msg = this.catMsg.find(x => x.keyLg == "binnacle.msgRecordsNotFound");
      this.eventService.warningMessage(_msg.textValue);
      return;
    }

    this.waitFor = true;
    this.eventService.startLoadingData();
    try {
      let _parametros = this.getParameters();
      this._serviceHistory.GetReportPDF(_parametros).subscribe({
        next: res => {
          let _result = res;
          console.log(res);

          let _blob = res;
          const a = document.createElement('a');
          const objectUrl = URL.createObjectURL(_blob);
          a.href = objectUrl;
          a.download = "bitacora_listado" + '.pdf';
          a.click();
          URL.revokeObjectURL(objectUrl);
          this.eventService.completeLoadingData();
          this.waitFor = false;
        },
        error: error => {
          console.log(error);
          let _msg = this.catMsg.find(x => x.keyLg == "common.error500_download");
          this.eventService.errorMessage(0, _msg.textValue);
          this.eventService.completeLoadingData();
          this.waitFor = false;
        }
      });

    } catch (error) {
      console.log(error);
      this.eventService.completeLoadingData();
      this.waitFor = false;
    }
  }

  onExportExcel(): any {

    if (this.emptyDataList) {
      let _msg = this.catMsg.find(x => x.keyLg == "binnacle.msgRecordsNotFound");
      this.eventService.warningMessage(_msg.textValue);
      return;
    }

    this.waitFor = true;
    this.eventService.startLoadingData();
    try {
      let _parametros = this.getParameters();
      this._serviceHistory.GetReportExcel(_parametros).subscribe({
        next: res => {
          let _result = res;
          console.log(res);

          let _blob = res;
          const a = document.createElement('a');
          const objectUrl = URL.createObjectURL(_blob);
          a.href = objectUrl;
          a.download = "bitacora_listado" + '.xlsx';
          a.click();
          URL.revokeObjectURL(objectUrl);
          this.eventService.completeLoadingData();
          this.waitFor = false;
        },
        error: error => {
          console.log(error);
          let _msg = this.catMsg.find(x => x.keyLg == "common.error500_download");
          this.eventService.errorMessage(0, _msg.textValue);
          this.eventService.completeLoadingData();
          this.waitFor = false;
        }
      });

    } catch (error) {
      console.log(error);
      this.eventService.completeLoadingData();
      this.waitFor = false;
    }
  }



  loadData(): any {
    this.waitFor = true;
    this.eventService.startLoadingData();

    try {
      let _parametros = this.getParameters();

      this._serviceHistory.getHistoryList(_parametros, this.currentPage).subscribe({
        next: res => {
          let _result = res;
          console.log("GetHistoryList=> ", res);

          if (res.ok) {
            this.dataInformation = res.body.content;
            this.waitFor = false;
            this.totalPages = res.body.totalPages;
            this.resetTable = false;
            localStorage.setItem('isInitLoad', '0');
            this.emptyDataList = _result.body.empty;
            this.IsPostBack = true;
            console.log(this.dataInformation);
          }
          else {
            let _msg = this.catMsg.find(x => x.keyLg == "common.errorGet");
            this.eventService.errorMessage(0, _msg.textValue);
          }

          this.eventService.completeLoadingData();
          this.waitFor = false;
        },
        error: error => {
          console.log(error);
          this._errorS.onValidateErrorCode(error);
          this.eventService.completeLoadingData();
          this.waitFor = false;
        }
      });

    } catch (error) {
      console.log(error);
      this.eventService.completeLoadingData();
      this.waitFor = false;
    }
  }

  onShowTableChild(id: any) {
    let _id = "#tbl_" + id;
    let _id2 = "#tbl2_" + id;
    let _icon = "#icon_" + id;

    if ($(_id).hasClass('d-none') || $(_id2).hasClass('d-none')) {
      $(_id).removeClass('d-none');
      $(_id2).removeClass('d-none');
      $(_icon).addClass('fa-angle-down');
      $(_icon).removeClass('fa-chevron-right');
    }
    else {
      $(_id).addClass('d-none');
      $(_id2).addClass('d-none');
      $(_icon).removeClass('fa-angle-down');
      $(_icon).addClass('fa-chevron-right');
    }
  }

  modelChanged(newObj, ctrolName) {
    if (ctrolName == "txtDateEnd") {
      this.onValidatePeriod();
    }
  }


  onValidatePeriod() {
    let txtDateInit = this.fmFilters.get('txtDateInit').value?.getTime();
    let txtDateEnd = this.fmFilters.get('txtDateEnd').value?.getTime();
    let diff = txtDateEnd - txtDateInit;
    let diffDays = (diff / (1000 * 60 * 60 * 24));
    if (diffDays > 31) {
      this.fmFilters.patchValue({ txtDateInit: this._util.fnAddDays(-30) });
      this.fmFilters.patchValue({ txtDateEnd: new Date() });
      $("#txtDateEnd").focus();
      let _msg = this.catMsg.find(x => x.keyLg === "binnacle.msgDateMax30");/** Before: "binnacle.msgDate30" */
      this.eventService.warningMessage(_msg.textValue);
      return;
    }

    let dateEnd = this.fmFilters.get('txtDateEnd').value;
    console.log(dateEnd);
    let _now = new Date();
    console.log(_now);
    if (dateEnd > _now) {
      this.fmFilters.patchValue({ txtDateEnd: new Date() });
      $("#txtDateEnd").focus();
      let _msg = this.catMsg.find(x => x.keyLg == "common.msgDateNotValid");
      this.eventService.warningMessage(_msg.textValue);
      return;
    }
  }

  protected changePage($event: any): void {
    this.currentPage = $event;
    this.ngOnInit();
  }

}